// extracted by mini-css-extract-plugin
export default {"noShimmer":"BZU8UN"};